import React from "react";

const Vinyl = () => {
  return (
    <>
      <section id="about-us" className="py-2">
      <div className="container">
        <div className="two-card-container">
          <article className="card">
          <h2>Vinyl</h2>
            <p>
            Vinyl flooring offers exceptional durability, making it a smart choice for high-traffic areas in your home. Its resilient nature allows it to withstand heavy foot traffic, spills, and daily wear and tear, making it ideal for busy households or commercial spaces. With vinyl flooring, you can enjoy long-lasting performance and peace of mind knowing that your floors can handle the demands of daily life.
            </p>
            <br />
            <p>
            Easy maintenance is another compelling reason to choose vinyl flooring. Its smooth and non-porous surface resists stains, moisture, and dirt, making it a breeze to clean. Regular sweeping or vacuuming, along with occasional mopping, is typically all that's needed to keep your vinyl floors looking pristine. Spend less time worrying about maintenance and more time enjoying your beautiful floors.
            </p>
            <br />
            <p>
            Vinyl flooring provides a wide range of design options to suit any style or aesthetic preference. It comes in various patterns, colors, and textures, including options that mimic the appearance of natural materials like hardwood or stone. Whether you want a modern, sleek look or a rustic, warm feel, vinyl flooring allows you to achieve the desired aesthetic for your space without compromising on durability or affordability.
            </p>
            <br />
          </article>
          <article className="card">
            <div className="director-photo">
            <img
                src={
                  "../Images/articles/vinyl_main.jpg"
                }
                alt="Vinyl"
                className="article-img"
              />
            </div>
          </article>
        </div>
      </div>
    </section>
    </>
  );
};

export default Vinyl;
